import React, { useEffect, useState } from 'react';
import Nav from '../Nav/Nav';
import MuvtechCard from './MuvtechCard';
import MuvtechCate from './MuvtechCate';

import { useParams } from 'react-router-dom';

import { useSelector } from 'react-redux';

function MuvtechProductList() {
  const { type } = useParams();

  const catedata = useSelector((state) => state.products[type]);
  // const iphoneglass = useSelector((state) => state.products.iphoneglass);
  console.log(catedata);

  const [muvtechcard, setmuvtechcard] = useState([]);

  useEffect(() => {
    // if (type === 'iphonecase') {
    //   setmuvtechcard(iphonecase);
    // } else if (type === 'iphoneglass') {
    //   setmuvtechcard(iphoneglass);
    // }
    setmuvtechcard(catedata);
  }, [type, catedata]);

  console.log(muvtechcard);

  return (
    <>
      <Nav />
      <div className="muvcate-productlist">
        <MuvtechCate />
      </div>

      <div className="muvtech-product-list">
        {muvtechcard.length === 0 ? (
          <p>Loading...</p>
        ) : (
          muvtechcard.map((item) => (
            <MuvtechCard key={item.id} item={item} type={type} />
          ))
        )}
      </div>
    </>
  );
}

export default MuvtechProductList;
